<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Date</th>
                            <td>{{value.date}}</td>
                        </tr>
                        <tr>
                            <th>Supplier</th>
                            <td>{{value.supplier ? value.supplier.display_name : null}}</td>
                        </tr>
                        <tr>
                            <th>Currency</th>
                            <td>{{value.currency ? value.currency.abbreviation : null}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>State</th>
                            <td>
                            <PStatus :state="value.state" v-if="value"/>
                            </td>
                        </tr>
                         <tr v-if="value.requisition">
                            <th>Requisition</th>
                            <td>
                                <span class="text-decoration-underline font-weight-bold" @click="showRequisition" style="cursor: pointer">
                                    {{value.requisition ? value.requisition.code : null}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Code</th>
                            <td>{{value.code}}</td>
                        </tr>
                         <tr>
                            <th>Receiving Point</th>
                            <td>{{value.receiving_point ? value.receiving_point : null}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-subheader></v-subheader>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" md="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Received</th>
                            <th>Billed</th>
                            <th>Price</th>
                            <th>Subtotal</th>
                            <th>Tax</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, i) in lines" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{l.item}}</td>
                            <td>{{formatNumber(l.quantity)}} {{l.measure_unit}}</td>
                            <td>
                                <!-- <span class="text-decoration-underline font-weight-bold" @click="showReceipts" style="cursor: pointer"> -->
                                    {{formatNumber(l.net_received)}} {{l.measure_unit}}
                                <!-- </span> -->
                            </td>
                            <td>
                                {{formatNumber(l.net_billed)}} {{l.measure_unit}}
                                <!-- <span class="text-decoration-underline font-weight-bold" @click="showReceipts" style="cursor: pointer">
                                </span> -->
                            </td>
                            <td>{{formatNumber(l.price)}}</td>
                            <td>{{formatNumber(l.subtotal)}}</td>
                            <td>{{formatNumber(l.tax)}}</td>
                            <td>{{value.currency ? value.currency.abbreviation : null}} {{formatNumber(l.total)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-divider>
        </v-divider>
        <v-row no-gutters justify="end">
            <v-col cols="12" md="4">
                <v-simple-table dense >
                    <tbody>
                        <tr>
                            <th>Subtotal</th>
                            <td>{{value.currency ? value.currency.abbreviation : null}} {{formatNumber(subtotal)}}</td>
                        </tr>
                        <tr>
                            <th>Tax</th>
                            <td>{{value.currency ? value.currency.abbreviation : null}} {{formatNumber(tax)}}</td>
                        </tr>
                        <tr>
                            <th>Total</th>
                            <td class="font-weight-bold">{{value.currency ? value.currency.abbreviation : null}} {{formatNumber(total)}} @ {{value.exchange_rate}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-subheader></v-subheader>
        <v-divider></v-divider>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Created by</th>
                            <td>{{value.created_by ? `${value.created_by.first_name} ${value.created_by.last_name}` : null}}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{formatDatetime(value.created_at)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { getTotal } from './../../utils/accounting';
import { formatNumber } from 'accounting';
import moment from 'moment';
import PStatus from './../common/PStatus';

export default {
    name: "PurchaseOrder",
    props: {
        value: {
            type: Object
        }
    },
    components: {
        PStatus
    },
    computed: {
        lines() {
            if(!this.value.lines) return [];
            return this.value.lines.map(line => ({
                ...line,
                item: line.item ? line.item.display_name : null,
                description: line.description,
                quantity: line.quantity,
                received: line.received,
                billed: line.billed,
                measure_unit: line.measure_unit.abbreviation,
                price: line.price,
                subtotal: this.lineSubtotal(line),
                tax: this.lineTax(line),
                total: this.lineTotal(line),
                notes: line.notes
            }))
        },
        subtotal() {
            return getTotal(this.lines, "subtotal");
        },
        tax() {
            return getTotal(this.lines, "tax");
        },
        total() {
            return getTotal(this.lines, "total");
        }
    },
    data() {
        return {

        }
    },
    methods: {
        lineSubtotal(line) {
            return line.quantity * line.price
        },
        lineTax(line) {
            return line.tax.rate * this.lineSubtotal(line)
        },
        lineTotal(line) {
            return this.lineSubtotal(line) + this.lineTax(line)
        },
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        formatDatetime(datetime) {
            return moment(datetime).format("YYYY-MM-DD");
        },
        showReceipts() {
            this.$router.push({ name: "GoodReceiptList", query: {order_code: this.value.code} })
        },
        showRequisition() {
             this.$router.push({ name: "PurchaseRequisitionDisplay", params: { id: this.value.requisition.id } });
        }
    }
}
</script>

<style>

</style>